"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TierTileCheckoutSnapshot = exports.TierPricingInfo = exports.TierFeature = exports.TestimonialCards = exports.PromoAppliedTag = exports.ProductTermToggle = exports.OrderSummary = exports.JoinButton = exports.BoostPricingTableVip = exports.BoostPricingTable = void 0;
var _react = _interopRequireDefault(require("react"));
var _checkBold = _interopRequireDefault(require("../../assets/svg/check-bold.svg"));
var _checkBoldBlack = _interopRequireDefault(require("../../assets/svg/check-bold-black.svg"));
var _tag = _interopRequireDefault(require("../../assets/svg/tag.svg"));
var _pricingGradientBorder = _interopRequireDefault(require("../../assets/svg/pricing-gradient-border.svg"));
var _x = _interopRequireDefault(require("../../assets/svg/x.svg"));
var _chevronDoubleBottom = _interopRequireDefault(require("../../assets/svg/chevron-double-bottom.svg"));
var _boost_testimonial_card = _interopRequireDefault(require("../../assets/boost/boost_testimonial_card-1.webp"));
var _boost_testimonial_card2 = _interopRequireDefault(require("../../assets/boost/boost_testimonial_card-2.webp"));
var _boost_testimonial_card3 = _interopRequireDefault(require("../../assets/boost/boost_testimonial_card-3.webp"));
var _boost_testimonial_card4 = _interopRequireDefault(require("../../assets/boost/boost_testimonial_card-4.webp"));
var _boost_testimonial_card1w = _interopRequireDefault(require("../../assets/boost/boost_testimonial_card-1w.webp"));
var _boost_testimonial_card2w = _interopRequireDefault(require("../../assets/boost/boost_testimonial_card-2w.webp"));
var _boost_testimonial_card3w = _interopRequireDefault(require("../../assets/boost/boost_testimonial_card-3w.webp"));
var _boost_testimonial_card4w = _interopRequireDefault(require("../../assets/boost/boost_testimonial_card-4w.webp"));
var _basic_bow = _interopRequireDefault(require("../../assets/boost/basic_bow.png"));
var _consts = require("../../consts");
var _boostHelpers = require("../../utils/boostHelpers");
var _CheckMark = _interopRequireDefault(require("../CheckMark"));
var _PricingTile = require("./PricingTile");
var _types = require("../../types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable jsx-a11y/click-events-have-key-events */
/* --- CONSTS --- */
var PRICING_CARD_MIN_WIDTH = 288;
var PRICING_CARD_MIN_WIDTH_MOBILE = 342;
var PRICING_CARD_MIN_HEIGHT = 554;

/* --- COMPONENTS --- */

var ProductTermToggle = exports.ProductTermToggle = function ProductTermToggle(_ref) {
  var checkoutTerm = _ref.checkoutTerm,
    setCheckoutTerm = _ref.setCheckoutTerm,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? "black" : _ref$theme,
    belowMd = _ref.belowMd;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex border-md p-1 rounded-full mx-auto text-black bg-opacity-50 border border-black ".concat(theme === "black" ? "bg-white" : "bg-black"),
    style: {
      width: belowMd ? 250 : 350
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    id: "term-toggle-monthly",
    type: "button",
    onClick: function onClick() {
      return setCheckoutTerm("monthly");
    },
    style: {
      transition: "all 0.3s ease",
      borderRadius: 9999
    },
    className: "relative font-semibold text-xs md:text-md rounded-full p-1 md:p-3 transition-colors focus:outline-none w-1/2 ".concat(checkoutTerm === "monthly" ? "bg-white" : "")
  }, "monthly plan"), /*#__PURE__*/_react["default"].createElement("button", {
    id: "term-toggle-yearly",
    type: "button",
    onClick: function onClick() {
      return setCheckoutTerm("yearly");
    },
    style: {
      transition: "all 0.3s ease",
      borderRadius: 9999
    },
    className: "relative font-semibold text-xs md:text-md rounded-full p-1 md:p-3 transition-colors focus:outline-none w-1/2 ".concat(checkoutTerm === "yearly" ? "bg-white" : "")
  }, "1-year plan"));
};
var PromoAppliedTag = exports.PromoAppliedTag = function PromoAppliedTag(_ref2) {
  var _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? "text-sm" : _ref2$className;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex justify-center items-center ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "mr-2",
    alt: "",
    src: _tag["default"]
  }), "Promo code applied");
};

/**
 *
 * @param {Object} props
 * @param {string} props.label - The label of the tier
 * @param {string} props.theme - white or black, default is black
 * @returns
 */
var TierLabel = function TierLabel(_ref3) {
  var label = _ref3.label,
    _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? "black" : _ref3$theme;
  return /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      width: 124,
      top: -15
    },
    className: "absolute left-0 right-0 m-auto top-1/2 flex justify-center items-center gap-2.5 py-1 px-1.5 text-lg font-bold ".concat(theme === "black" ? "bg-black text-white" : "bg-neutral-50 text-black")
  }, label);
};

/**
 *
 * @param {Object} props
 * @param {string} props.tierName - The name of the tier
 * @param {string} props.label - The name of the tier
 * @param {number} props.originalPrice - The original price
 * @param {string} props.price - The discounted price
 * @param {boolean} props.isMobile - The variant of the component
 * @param {string} props.theme - white or black, default is black
 * @returns
 */
var TierPricingInfo = exports.TierPricingInfo = function TierPricingInfo(props) {
  var tierName = props.tierName,
    label = props.label,
    originalPrice = props.originalPrice,
    price = props.price,
    isMobile = props.isMobile,
    _props$promotionAppli = props.promotionApplied,
    promotionApplied = _props$promotionAppli === void 0 ? false : _props$promotionAppli,
    _props$isYearly = props.isYearly,
    isYearly = _props$isYearly === void 0 ? false : _props$isYearly,
    _props$priceHidden = props.priceHidden,
    priceHidden = _props$priceHidden === void 0 ? false : _props$priceHidden,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? "black" : _props$theme;
  var discountPercentage = (0, _boostHelpers.calculateDiscount)(price, originalPrice);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col h-full w-full ".concat(isMobile ? "pt-6" : "pt-8", " px-6")
  }, Boolean(label) && /*#__PURE__*/_react["default"].createElement(TierLabel, {
    label: label,
    theme: theme
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold ".concat(isMobile ? "text-3xl" : "text-4xl")
  }, tierName), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      backgroundColor: tierName === _consts.boostTiers.VIP ? "#4BFF87" : "#87DDA4",
      paddingRight: 10,
      paddingLeft: 10
    },
    className: "whitespace-nowrap text-black text-center font-gilroy font-bold text-2xl ml-1 rounded-xl py-3 md:py-2 lg:py-3"
  }, discountPercentage, "% off")), !priceHidden && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col",
    style: {
      marginTop: isMobile ? 14 : 24,
      lineHeight: "normal"
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold text-base"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "$", price.toFixed(2), "/", isYearly ? "yr" : "mo")), promotionApplied && /*#__PURE__*/_react["default"].createElement("span", {
    className: "mt-1 mb-2 self-start"
  }, /*#__PURE__*/_react["default"].createElement(PromoAppliedTag, null)), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: "#9C9C9C"
    },
    className: "mt-2 text-base font-normal line-through font-strikethrough"
  }, "$", originalPrice.toFixed(2), "/", isYearly ? "yr" : "mo")));
};

/**
 *
 * @param {Object} props
 * @param {string} props.title - The button title
 * @param {function} props.onClick - onClick handler
 * @param {boolean} props.isHighlighted - Whether the tier is highlighted
 * @returns
 */
var JoinButton = exports.JoinButton = function JoinButton(props) {
  var title = props.title,
    onClick = props.onClick,
    isHighlighted = props.isHighlighted;
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onClick,
    style: {
      maxWidth: 262
    },
    className: "h-10 w-full rounded items-center justify-center self-center px-4 text-lg font-medium hover:text-white ".concat(isHighlighted ? "bg-boost-primary-500 hover:bg-boost-primary-400 text-white" : "border border-neutral-300 bg-neutral-50 hover:bg-boost-primary-500 text-black", " ")
  }, /*#__PURE__*/_react["default"].createElement("span", null, title));
};

/**
 *
 * @param {Object} props
 * @param {Object} props.feature - The feature object
 * @param {string} props.feature.title - The title of the feature
 * @param {Array.<{text: string, style: React.CSSProperties}>} props.feature.description - The perks of the feature
 * @returns
 */
var TierFeature = exports.TierFeature = function TierFeature(_ref4) {
  var _feature$description;
  var feature = _ref4.feature,
    _ref4$isMobile = _ref4.isMobile,
    isMobile = _ref4$isMobile === void 0 ? false : _ref4$isMobile,
    _ref4$theme = _ref4.theme,
    theme = _ref4$theme === void 0 ? "black" : _ref4$theme,
    _ref4$checkMarkStyle = _ref4.checkMarkStyle,
    checkMarkStyle = _ref4$checkMarkStyle === void 0 ? {} : _ref4$checkMarkStyle;
  var checkStyle = _objectSpread({
    width: isMobile ? 16 : 24,
    color: theme === "black" ? "white" : "black",
    alignTop: !!isMobile
  }, checkMarkStyle);
  return /*#__PURE__*/_react["default"].createElement(_CheckMark["default"], checkStyle, (_feature$description = feature.description) === null || _feature$description === void 0 ? void 0 : _feature$description.map(function (_ref5) {
    var text = _ref5.text,
      style = _ref5.style;
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: text,
      className: "text-base ml-1",
      style: _objectSpread({
        lineHeight: 1.18
      }, style)
    }, text);
  }));
};

/**
 *
 * @param {Object} props
 * @param {string} props.tier - selected term
 * @param {string} props.selectedTerm - selected tier
 * @param {boolean} props.isHighlighted - fixed discount applied, if any
 * @param {boolean} props.promotionApplied - percentage of discount applied, if any
 * @param {number} props.price - percentage of discount applied, if any
 * @param {string} [props.theme] - white or black, default is black
 * @returns
 */
var TierTileCheckoutSnapshot = exports.TierTileCheckoutSnapshot = function TierTileCheckoutSnapshot(_ref6) {
  var _boostProductTierConf;
  var tier = _ref6.tier,
    selectedTerm = _ref6.selectedTerm,
    isHighlighted = _ref6.isHighlighted,
    promotionApplied = _ref6.promotionApplied,
    price = _ref6.price,
    _ref6$theme = _ref6.theme,
    theme = _ref6$theme === void 0 ? "black" : _ref6$theme;
  var tierConfig = (_boostProductTierConf = _consts.boostProductTierConfig_v3[selectedTerm]) === null || _boostProductTierConf === void 0 ? void 0 : _boostProductTierConf[tier];
  var isYearly = selectedTerm === "yearly";
  var _ref7 = tierConfig || {},
    name = _ref7.name,
    _ref7$originalPrice = _ref7.originalPrice,
    originalPrice = _ref7$originalPrice === void 0 ? 0 : _ref7$originalPrice,
    label = _ref7.label,
    featuresMobile = _ref7.featuresMobile;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_PricingTile.BoostPricingTileComponent, {
    isMobile: true,
    isHighlighted: isHighlighted,
    tileTheme: isHighlighted ? "light" : theme === "black" ? "light" : "dark",
    tier: tier,
    term: selectedTerm,
    features: featuresMobile,
    isSecondaryJoinVisible: false,
    isPrimaryJoinVisible: false,
    styleOverrides: {
      container: {
        minHeight: PRICING_CARD_MIN_HEIGHT
      }
    },
    className: "p-10 mdl:p-10 xxl:p-10 h-auto"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative",
    style: {
      width: 325
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-transparent ".concat(theme === "black" ? "to-black" : "to-white", " opacity-75 pointer-events-none z-10")
  }), " ", /*#__PURE__*/_react["default"].createElement(TestimonialCards, {
    cardWidth: 270,
    theme: theme
  })));
};

/**
 *
 * @param {Object} props
 * @param {BoostTerm} props.productTerm - selected term
 * @param {BoostTier} props.productTier - selected tier
 * @param {number} props.promotionCredit - fixed discount applied, if any
 * @param {number} props.promotionPercentOff - percentage of discount applied, if any
 * @returns
 */
var OrderSummary = exports.OrderSummary = function OrderSummary(_ref8) {
  var _boostProductTierConf2;
  var productTerm = _ref8.productTerm,
    productTier = _ref8.productTier,
    promotionCredit = _ref8.promotionCredit,
    promotionPercentOff = _ref8.promotionPercentOff;
  var selectedConfig = ((_boostProductTierConf2 = _consts.boostProductTierConfig[productTerm]) === null || _boostProductTierConf2 === void 0 ? void 0 : _boostProductTierConf2[productTier]) || {};
  var price = selectedConfig.price;
  var promotionApplied = promotionCredit > 0 || promotionPercentOff > 0;
  var priceAfterDiscount = (0, _boostHelpers.calculatePriceAfterPromotion)(price, promotionPercentOff, promotionCredit);
  var promotionAmount = (price - priceAfterDiscount).toFixed(2);
  var isYearly = productTerm === "yearly";
  var pricing = isYearly ? "".concat((price / 12).toFixed(2), " x 12 months") : price;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-black flex flex-col space-y-2 mb-5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold"
  }, "Order Summary"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "".concat(productTier, " (").concat(productTerm, ")")), /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(promotionApplied ? "line-through" : "")
  }, "$", pricing)), promotionApplied && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between",
    style: {
      color: "#107332"
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement(PromoAppliedTag, {
    className: "text-md mr-2"
  }), promotionPercentOff ? "(".concat(promotionPercentOff, "% off)") : "", promotionCredit ? "($".concat(promotionCredit.toFixed(2), " off)") : ""), /*#__PURE__*/_react["default"].createElement("span", null, "-$", promotionAmount)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "border-b-2 border-neutral-400"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between font-semibold"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Total"), /*#__PURE__*/_react["default"].createElement("span", null, "$", priceAfterDiscount)));
};

/**
 *
 * @param {Object} props
 * @param {string} props.cardWidth - width of card
 * @returns
 */
var TestimonialCards = exports.TestimonialCards = function TestimonialCards(_ref9) {
  var _ref9$cardWidth = _ref9.cardWidth,
    cardWidth = _ref9$cardWidth === void 0 ? 295 : _ref9$cardWidth,
    _ref9$theme = _ref9.theme,
    theme = _ref9$theme === void 0 ? "black" : _ref9$theme;
  var testimonialCards = theme === "black" ? [_boost_testimonial_card["default"], _boost_testimonial_card2["default"], _boost_testimonial_card3["default"], _boost_testimonial_card4["default"]] : [_boost_testimonial_card1w["default"], _boost_testimonial_card2w["default"], _boost_testimonial_card3w["default"], _boost_testimonial_card4w["default"]];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "-ml-4 flex overflow-x-scroll hide-x-scrollbar flex-shrink-0"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-4 py-4 flex self-start overflow-visible"
  }, testimonialCards.map(function (imageSrc, idx) {
    return /*#__PURE__*/_react["default"].createElement("img", {
      alt: "",
      src: imageSrc
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: "testimonial-".concat(idx),
      style: {
        width: cardWidth,
        height: "auto"
      },
      className: "pr-6 box-content transform hover:scale-110 transition-transform"
    });
  })));
};

/**
 *
 * @param {Object} props
 * @param {string[]} props.tiers - The tiers to display
 * @param {string} [props.highlightTier] - The tier to highlight
 * @param {string} [props.checkoutTerm] - The selected term
 * @param {boolean} [props.isMobileView] - should show mobile view
 * @param {"white" | "black"} [props.theme] - white or black, default is black
 * @param {Function} [props.buttonClickCallback] - onClick handler, arguments are tier and term
 * @param {React.ReactNode} [props.headerComponent] - The header component
 * @param {string[]} [props.selectedFeatures] - The selected features from BOOST_SUBSCRIPTION_FEATURES
 * @param {boolean} [props.isSecondaryJoinVisible] - should show secondary join button
 * @returns
 */
var BoostPricingTable = exports.BoostPricingTable = function BoostPricingTable(_ref10) {
  var tiers = _ref10.tiers,
    highlightTier = _ref10.highlightTier,
    _ref10$checkoutTerm = _ref10.checkoutTerm,
    checkoutTerm = _ref10$checkoutTerm === void 0 ? "monthly" : _ref10$checkoutTerm,
    _ref10$buttonClickCal = _ref10.buttonClickCallback,
    buttonClickCallback = _ref10$buttonClickCal === void 0 ? function () {} : _ref10$buttonClickCal,
    _ref10$isMobileView = _ref10.isMobileView,
    isMobileView = _ref10$isMobileView === void 0 ? false : _ref10$isMobileView,
    _ref10$theme = _ref10.theme,
    theme = _ref10$theme === void 0 ? "black" : _ref10$theme,
    headerComponent = _ref10.headerComponent,
    _ref10$selectedFeatur = _ref10.selectedFeatures,
    selectedFeatures = _ref10$selectedFeatur === void 0 ? Object.keys(_consts.BOOST_SUBSCRIPTION_FEATURES) : _ref10$selectedFeatur,
    _ref10$isSecondaryJoi = _ref10.isSecondaryJoinVisible,
    isSecondaryJoinVisible = _ref10$isSecondaryJoi === void 0 ? false : _ref10$isSecondaryJoi;
  var TABLE_COLUMN_WIDTH = 312;
  var TABLE_ROW_HEIGHT = 56;
  var TABLE_HEADER_HEIGHT = 248;
  var tableHeaderStyle = {
    width: TABLE_COLUMN_WIDTH,
    height: TABLE_HEADER_HEIGHT,
    borderWidth: 1,
    borderColor: "#4B4B4B"
  };
  var rowStyle = {
    height: TABLE_ROW_HEIGHT
  };

  // height = header + (row * number of features) - random offset to match the design
  var tableHeight = TABLE_HEADER_HEIGHT + TABLE_ROW_HEIGHT * (selectedFeatures.length + 1); // additional row for button

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, headerComponent, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center ".concat(isMobileView ? "flex-col space-y-6" : "flex-row space-x-10")
  }, tiers.map(function (t, idx) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: t,
      className: "flex-1 w-full"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "mb-4 w-full"
    }, /*#__PURE__*/_react["default"].createElement(_PricingTile.BoostPricingTile, {
      tier: t,
      selectedTerm: checkoutTerm,
      onJoin: buttonClickCallback,
      isHighlighted: t === highlightTier,
      theme: theme,
      isMobile: isMobileView,
      isSecondaryJoinVisible: isSecondaryJoinVisible
    })), idx === 0 && tiers.length > 1 && /*#__PURE__*/_react["default"].createElement("span", {
      className: "flex justify-center items-center ".concat(isMobileView ? "visible" : "hidden")
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _chevronDoubleBottom["default"],
      alt: "More plans",
      style: {
        height: 16,
        width: 16,
        animation: "arrow-bounce 2s ease-in-out infinite"
      }
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: "font-medium"
    }, "More plans")));
  })));
};

/**
 *
 * @param {Object} props
      * @param {string} props.tiers - The tiers to display
      * @param {string} props.highlightTier - The tier to highlight
      * @param {function} props.handleClick - onClick handler, argment is tier and term
      * @param {boolean} props.isMobileView - should show mobile view
      * @param {string} props.theme - white or black, default is black
      * @returns
      */
var BoostPricingTableVip = exports.BoostPricingTableVip = function BoostPricingTableVip(_ref11) {
  var _boostProductTierConf3, _boostProductTierConf4;
  var tiers = _ref11.tiers,
    highlightTier = _ref11.highlightTier,
    _ref11$checkoutTerm = _ref11.checkoutTerm,
    checkoutTerm = _ref11$checkoutTerm === void 0 ? "monthly" : _ref11$checkoutTerm,
    _ref11$buttonClickCal = _ref11.buttonClickCallback,
    buttonClickCallback = _ref11$buttonClickCal === void 0 ? function () {} : _ref11$buttonClickCal,
    _ref11$isMobileView = _ref11.isMobileView,
    isMobileView = _ref11$isMobileView === void 0 ? false : _ref11$isMobileView,
    _ref11$theme = _ref11.theme,
    theme = _ref11$theme === void 0 ? "black" : _ref11$theme;
  var tierConfig = (_boostProductTierConf3 = _consts.boostProductTierConfig[checkoutTerm]) === null || _boostProductTierConf3 === void 0 ? void 0 : _boostProductTierConf3[_consts.boostTiers.VIP];
  var secondaryTerm = checkoutTerm === "monthly" ? "yearly" : "monthly";
  var secondaryTierConfig = (_boostProductTierConf4 = _consts.boostProductTierConfig[secondaryTerm]) === null || _boostProductTierConf4 === void 0 ? void 0 : _boostProductTierConf4[_consts.boostTiers.VIP];
  var _ref12 = tierConfig || {},
    name = _ref12.name,
    buttonText = _ref12.buttonText,
    _ref12$price = _ref12.price,
    price = _ref12$price === void 0 ? 0 : _ref12$price,
    _ref12$originalPrice = _ref12.originalPrice,
    originalPrice = _ref12$originalPrice === void 0 ? 0 : _ref12$originalPrice,
    label = _ref12.label,
    featuresSelected = _ref12.featuresSelected;
  var _calculatePerMonthPri = (0, _boostHelpers.calculatePerMonthPrice)(checkoutTerm, price, originalPrice),
    perMonthPrice = _calculatePerMonthPri.perMonthPrice,
    perMonthOriginalPrice = _calculatePerMonthPri.perMonthOriginalPrice;
  var backgroundStyle = theme === "black" ? "linear-gradient(to bottom, #BB99FF, #BB99FF1A)" : "#BB99FF";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-start justify-center ".concat(isMobileView ? "flex-col space-y-6" : "flex-row space-x-6")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-4 w-full bg-boost-primary-50 flex flex-col justify-center p-6 leading-tight",
    style: {
      borderRadius: 10,
      width: isMobileView ? PRICING_CARD_MIN_WIDTH_MOBILE : PRICING_CARD_MIN_WIDTH,
      minHeight: isMobileView ? undefined : PRICING_CARD_MIN_HEIGHT,
      letterSpacing: -0.25
    }
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "font-bold"
  }, "NEW!"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "mt-1"
  }, "VIP members get access to credit dispute and more!")), [_consts.boostTiers.VIP].map(function (t, idx) {
    return /*#__PURE__*/_react["default"].createElement(_PricingTile.BoostPricingTileComponent, {
      isMobile: isMobileView,
      isHighlighted: false,
      tileTheme: "light",
      tier: t,
      term: checkoutTerm,
      secondaryConfig: secondaryTierConfig,
      buttonText: "Get ".concat(tierConfig.buttonText || tierConfig.name),
      features: featuresSelected,
      onJoin: buttonClickCallback,
      styleOverrides: {
        container: {
          height: PRICING_CARD_MIN_HEIGHT,
          width: isMobileView ? PRICING_CARD_MIN_WIDTH_MOBILE : PRICING_CARD_MIN_WIDTH
        }
      },
      isSecondaryJoinVisible: false
    });
  })));
};